export {
  default
} from './PricePromotion'
